import React, { FC, useEffect } from 'react'
import TopBanner from '../../components/TopBanner/TopBanner'
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs'
import { NavLink } from 'react-router-dom'
import s from './AboutUs.module.scss'
import { Helmet } from 'react-helmet-async'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import { fetchAboutUs } from '../../store/slices/aboutUsSlice'

import MoreAboutUs from './MoreAboutUs/MoreAboutUs'
import OurTeam from './OurTeam/OurTeam'
import { scrollToTop } from '../../utils'

const AboutUs: FC = () => {
    const dispatch = useAppDispatch();
    const { aboutUs, loading } = useAppSelector(state => state.aboutUs);

    useEffect(() => {
        scrollToTop()
        dispatch(fetchAboutUs());
    }, [dispatch]);

    return (
        <>
            <Helmet>
                <title>О нас | Phoenix Programs</title>

                <meta
                    name="description"
                    content="О компании Phoenix Programs — команда инженеров и разработчиков в области автоматизации технологических процессов, программирования ПЛК и SCADA-систем."
                />

                <link rel="canonical" href="https://phoenix-programs.ru/about-us" />

                {/* Open Graph */}
                <meta property="og:type" content="website" />
                <meta property="og:locale" content="ru_RU" />
                <meta property="og:url" content="https://phoenix-programs.ru/about-us" />
                <meta property="og:title" content="О нас | Phoenix Programs" />
                <meta property="og:description" content="Команда инженеров и разработчиков Phoenix Programs — автоматизация, ПЛК, SCADA и промышленные решения." />
                <meta property="og:image" content="https://phoenix-programs.ru/logo192.png" />

                {/* Twitter */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="О нас | Phoenix Programs" />
                <meta name="twitter:description" content="Команда инженеров и разработчиков Phoenix Programs — автоматизация, ПЛК, SCADA и промышленные решения." />
                <meta name="twitter:image" content="https://phoenix-programs.ru/logo192.png" />

                <meta name="robots" content="index, follow" />
            </Helmet>
            <TopBanner title='О нас' />
            <Breadcrumbs>
                <NavLink className={({ isActive }) => isActive ? s.active : ''} to={'/'} >Главная</NavLink>
                /
                <NavLink className={({ isActive }) => isActive ? s.active : ''} to={'/about-us'} >О нас</NavLink>
            </Breadcrumbs>
            {!loading && aboutUs && (
                <>
                    <OurTeam description={aboutUs.description} image={aboutUs.images} />
                    <MoreAboutUs sections={aboutUs.sections} />
                </>
            )}
        </>
    )
}

export default AboutUs